export enum AvailableColors {
  'black' = '#000000',
  'green' = '#008000',
  'yellow' = '#FFFF00',
  'white' = '#FFFFFF',
  'purple' = '#e6dfed',
  'red' = '#FF0000',
  'spacegray' = '#302E2D',
  'midnightgreen' = '#004953',
  'gold' = '#EBCFC4',
  'silver' = '#C0C0C0',
  'rosegold' = '#B76E79',
  'coral' = '#FF7F50',
  'midnight' = '#1d242d',
  'spaceblack' = '#1F1F1F',
  'blue' = '#266282',
  'pink' = '#FFC0CB',
  'graphite' = '#383A3C',
  'sierrablue' = '#5DADEC',
  'space gray' = '#808080',
  'rose gold' = '#B76E79',
  'sky blue' = '#87CEEB',
  'starlight' = '#F4F4F4',
}
